<template>
    <div class='main'>
        <div class='tabs is-midium is-boxed'>
            <ul>
                <li @click='changeMode("eventManage")' v-bind:class='{ "is-active": eventManage }'>
                    <a>
                        <span class='icon is-small'><i class="fas fa-calendar"></i></span>
                        <span>行事管理</span>
                    </a>
                </li>
                <li @click='changeMode("profile")' v-bind:class='{ "is-active": profile }'>
                    <a>
                        <span class='icon is-small'><i class="fas fa-address-card"></i></span>
                        <span>プロフィール設定</span>
                    </a>
                </li>
                <li @click='changeMode("orderHistory")' v-bind:class='{ "is-active": orderHistory }'>
                    <a>
                        <span class='icon is-small'><i class="fas fa-shopping-cart"></i></span>
                        <span>購入履歴</span>
                    </a>
                </li>
                <li @click='changeMode("downloads")' v-bind:class='{ "is-active": downloads }'>
                    <a>
                        <span class='icon is-small'><i class="fas fa-download"></i></span>
                        <span>写真ダウンロード</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class='content'>
            <EventManage v-if='eventManage'></EventManage>
            <Profile v-if='profile'></Profile>
            <OrderHistory v-if='orderHistory'></OrderHistory>
            <Downloads v-if='downloads'></Downloads>
        </div>
    </div>
</template>

<script>

import EventManage from '@/components/photobuy/pages/EventManage.vue'
import Profile from '@/components/photobuy/pages/Profile.vue'
import OrderHistory from '@/components/photobuy/pages/OrderHistory.vue'
import Downloads from '@/components/photobuy/pages/Downloads.vue'

export default {
    name: 'Mypage',
    props: [],
    components: {
        EventManage,
        Profile,
        OrderHistory,
        Downloads
    },
    data () {
        return {
            eventManage: true,
            profile: false,
            orderHistory: false,
            downloads: false
        }
    },
    mounted () {
        switch (this.$route.query.to) {
        case 'profile':
            this.changeMode('profile')
            break
        case 'downloads':
            this.changeMode('downloads')
            break
        }
    },
    methods: {
        changeMode (mode) {
            this.$data.eventManage = false
            this.$data.profile = false
            this.$data.orderHistory = false
            this.$data.downloads = false

            this.$data[mode] = true
        }
    }
}
</script>

<style scoped>

.main {
    max-width: 1280px;
    min-height: calc(100vh - 80px);
    margin: auto;
}

.tabs {
    overflow: hidden;
    max-width: 1280px;
    width: calc(100vw);
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
}

.content {
    margin-left: 20px;
}

@media (max-width: 600px) {
    .main {
        width: 100%;
        overflow-x: hidden;
    }

    .tabs {
        width: 100%;
        max-width: 100%;
        overflow: visible;
        padding: 12px 10px 0;
        box-sizing: border-box;
    }

    .tabs ul {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
        border-bottom: none;
    }

    .tabs li {
        width: 100%;
    }

    .tabs li a {
        justify-content: center;
        min-height: 42px;
        padding: 8px 6px;
        border: 1px solid #dbdbdb;
        border-radius: 6px;
        font-size: 13px;
        white-space: nowrap;
    }

    .tabs.is-boxed li.is-active a {
        border-color: #3273dc;
        background: #eff5ff;
    }

    .content {
        margin-left: 0;
        padding: 0 10px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/Mypage.vue